import moment from "moment";
import { getFromLocalStorage } from "../hooks/useLocalStorage";


function formatedDate(date){
    // AM-PM clock
    // return  moment(date).format("DD-MMM-YYYY hh:mm A")
    
    
    // 24 hour clock
    // return  moment(date).format("DD-MMM-YYYY HH:mm:ss")  


    if (getFromLocalStorage('ROLE')?.key == "ADMIN") {
        // 24 hour clock format
        return moment(date).format("DD-MMM-YYYY HH:mm:ss");
    } else {
        // AM-PM clock format
        return moment(date).format("DD-MMM-YYYY");
    }
    
    
}

export function formattedDateTime(date){
    return  moment(date).format("DD-MMM-YYYY HH:mm:ss")  //for date with time
}

export function formattedDateTime2(date){
    return  moment(date).format("DD-MM-YYYY HH:mm:ss")  //for date with time
}

export function formattedDateOnly(date){
    return  moment(date).format("DD-MMM-YYYY")  //for date without time
}

export function formattedCoverageDate(date1, date2){
    return  moment(date1).format("DD-MMM-YYYY") +' to '+ moment(date2).format("DD-MMM-YYYY") //for date without time
}
export default formatedDate;